export default __webpack_public_path__ + "c16e46ed9576d27d6c8e6223680006c0.png";